import { InvoiceGovernmentTypeLabel } from '@/core/domain/invoice/invoice/invoice.enums';
import { Select, SelectProps } from 'antd';

export default function SelectGovernmentType(props: SelectProps) {
  const options = Object.keys(InvoiceGovernmentTypeLabel).map((key) => ({
    value: key,
    label:
      InvoiceGovernmentTypeLabel[
        key as keyof typeof InvoiceGovernmentTypeLabel
      ],
  }));

  return (
    <Select
      {...props}
      options={options}
      style={{ ...props.style, width: '100%' }}
    />
  );
}
